import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Widget rendering a part of an accounting document. This should only
 * be used in top-level elements of a document.
 */
export default class AccountingDocumentWidget extends Widget {
	constructor() {
		super(...arguments);

		this._documentState = undefined;
	}

	setup({ documentState }) {
		this._documentState = documentState;
	}
}
